export default __webpack_public_path__ + "static/media/calendar.4bb2c83f.svg";